import request from './index'

export const remoteTakePicture=(carId)=>{
    return request({
        url:'/remoteTake/remoteTakePicture',
        method:'post',
        data:{
            command_id:"72",
            carId:carId,
            controlFlag:1
        }
    })
}

export const rtmpControl=(carId,flag)=>{
    return request({
        url:'/remoteTake/rtmpControl',
        method:'post',
        data:{
            command_id:"70",
            carId:carId,
            controlFlag:flag
        }
    })
}

export const remoteControl=(carId,quadrantSend,angleSend,levelSend,lightFlag,sweepFlag,securityFlag)=>{
    return request({
        url:'/remoteTake/remoteControl',
        method:'post',
        data:{
            command_id : "71",
            carId : carId,
            ccuType : "49",
            ccuSel : "0",
            ccuQuadrant : quadrantSend,
            ccuAngle : angleSend,
            ccuLevel : levelSend,
            ccuLight : lightFlag,
            ccuSpare : "0",
            ccuCheck : "0",
            ccuSweep : sweepFlag,
            ccuSecurity: securityFlag,
        }
    })
}